import {clearPhone} from '@/services/string';
import BaseService from '@/services/base_service';

export default class MenuService extends BaseService {
    list(params) {
        return new Promise((resolve, reject) => {
            axios.get('/menu', params).then(response => {
                resolve(response);
            }).catch(e => {
                reject(e);
            });
        });
    }

    get(id) {
        return new Promise((resolve, reject) => {
            axios.get('/menu/' + id).then(response => {
                resolve(response);
            }).catch(e => {
                reject(e);
            });
        });
    }

    create(model) {
        return new Promise((resolve, reject) => {
            axios.post('/menu', model).then(response => {
                resolve(response);
            }).catch(e => {
                reject(this.getErrors(e));
            });
        });
    }

    update(model) {
        return new Promise((resolve, reject) => {
            axios.put('/menu/' + model.id, model).then(response => {
                resolve(response);
            }).catch(e => {
                reject(this.getErrors(e));
            });
        });
    }

    sort(id, model) {
      return new Promise((resolve, reject) => {
         axios.put('/menu/' + id + '/ordenar', model).then(response => {
            resolve(response);
         }).catch(e => {
            reject(this.getErrors(e));
         });
      });
   }

    delete(id) {
        return new Promise((resolve, reject) => {
            axios.delete('/menu/' + id).then(response => {
                resolve(response);
            }).catch(e => {
                reject(e);
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/services/menu.js